// extracted by mini-css-extract-plugin
export default {"root":"iQN9Ge93o4EGKG6iG6zC","tag":"_7sWO9pww8nO9yUVcd70u","hidden-popper":"dn_8z0phwWTrusPQswEJ","hiddenPopper":"dn_8z0phwWTrusPQswEJ"};